import { TInvoiceForm } from '../types'

export const NEW_INVOICE_DRAFT_STORAGE_KEY = 'invoice:new:draft'
export const NEW_INVOICE_DRAFT_VERSION = 2

export type NewInvoiceDraftClient = {
  tradingName: string
  email: string
  billingAddress: string
  name?: string
  lastName?: string
}

export type NewInvoiceDraftPayload = {
  version: number
  values: TInvoiceForm
  paymentInstructionsDraft?: string
  draftClient?: NewInvoiceDraftClient
}

export const saveNewInvoiceDraft = (draft: {
  values: TInvoiceForm
  paymentInstructionsDraft?: string
  draftClient?: NewInvoiceDraftClient
}): void => {
  if (typeof window === 'undefined') return
  try {
    const payload: NewInvoiceDraftPayload = {
      version: NEW_INVOICE_DRAFT_VERSION,
      values: draft.values,
      paymentInstructionsDraft: draft.paymentInstructionsDraft,
      ...(draft.draftClient ? { draftClient: draft.draftClient } : {}),
    }
    window.localStorage.setItem(NEW_INVOICE_DRAFT_STORAGE_KEY, JSON.stringify(payload))
  } catch {
    // ignore quota / private mode errors
  }
}

export const clearNewInvoiceDraftStorage = (): void => {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(NEW_INVOICE_DRAFT_STORAGE_KEY)
  } catch {
    // ignore quota / private mode errors
  }
}
